import { createContext, useContext, useEffect, useState } from 'react';
import * as authApi from '../api/auth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setUser(null);
  };

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      setLoading(false);
      return;
    }
    authApi
      .me()
      .then((r) => setUser(r.data))
      .catch(() => logout())
      .finally(() => setLoading(false));

    window.addEventListener('auth:logout', logout);
    return () => window.removeEventListener('auth:logout', logout);
  }, []);

  const login = async (email, senha) => {
    const { data } = await authApi.login(email, senha);
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);
    const { data: userData } = await authApi.me();
    setUser(userData);
    return userData;
  };

  const atualizarUsuario = async (dados) => {
    const { data } = await authApi.updateMe(dados);
    setUser(data);
    return data;
  };

  const alterarSenha = async (senhaAtual, novaSenha) => {
    const { data } = await authApi.alterarSenha(senhaAtual, novaSenha);
    // troca de senha revoga o token antigo no backend — grava o par novo pra sessão continuar
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, atualizarUsuario, alterarSenha }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
